<template>
    <div class="tabs-wrapper rs_preserve">
        <div class="tabs">
            <div class="tab-container px-0">
                <div class="d-flex tablist" role="tablist">
                  <button
                        class="tab nav-item nav-link cursor-pointer no-style-btn"
                        :class="{ 'active': activeTabIndex === 1 }"
                        id="nav-list-tab"
                        role="tab"
                        aria-controls="nav-list"
                        aria-selected="false"
                        aria-label="Visa som lista"
                        @click.prevent="handleTabClick(1)"
                    >
                        <i class="fas fa-list mr-2"></i>
                        <span class="d-none d-sm-inline-block">VISA SOM LISTA</span>
                        <b-badge v-if="searchQuery !== ''" class="ml-1 filter-badge" variant="light">({{ matchingResults }})<span class="sr-only">matchande kulturarv</span></b-badge>
                    </button>
                    <button
                        class="tab nav-item nav-link cursor-pointer no-style-btn"
                        :class="{ 'active': activeTabIndex === 0 }"
                        id="nav-map-tab"
                        role="tab"
                        aria-controls="nav-map"
                        aria-selected="true"
                        aria-label="Visa på karta"
                        @click.prevent="handleTabClick(0)"
                    >
                        <i class="fas fa-map-marked-alt mr-2"></i>
                        <span class="d-none d-sm-inline-block">VISA PÅ KARTA</span>
                        <b-badge v-if="searchQuery !== ''" class="ml-1 filter-badge" variant="light">({{ matchingLocations }})<span class="sr-only">matchande platser</span></b-badge>
                    </button>
                </div>
                <div class="search-filters d-flex align-items-center">
                    <slot></slot>
                </div>
        </div>
      </div>
    </div>
</template>

<script>
/* global Bus */
import { mapGetters, mapState } from 'vuex'
import store from '../../store'

export default {
  name: 'SearchTabs',

  props: ['tabName', 'test'],

  data: function () {
    return {
      searchParams: new URLSearchParams()
    }
  },

  async mounted () {
    await store.restored
    // this.$store.commit('setActiveTabIndex', this.tabName === 'karta' ? 0 : 1)
    Bus.$on('switchTab', function (tabIndex) {
      store.commit('setActiveTabIndex', tabIndex)
    })
    const currentUrl = window.location.href
    if (_.includes(currentUrl, 'nearMe')) {
      setTimeout(function () {
        Bus.$emit('nearMe', true)
      }, 500)
      window.history.replaceState(null, null, _.replace(currentUrl, '/nearMe', ''))
    }
  },

  methods: {
    getActiveClass: function (index) {
      return this.activeTabIndex === index ? 'show active' : ''
    },

    handleTabClick: function (index) {
      this.activeTabIndex = index

      const baseUrl = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' ? '/databas/sok/' : '/sok/'
      const searchUrl = this.activeTabIndex === 0 ? 'karta' : 'lista'
      const searchQuery = this.searchQuery

      _.each(this.filters, (f, key) => {
        if (_.size(f) > 0 || (typeof f === 'number' && f > 0)) {
          const v = typeof f === 'object' ? f.join(',') : f
          this.searchParams.set(key, v)
        } else {
          this.searchParams.delete(key)
        }
      })

      if (!this.isOnSearchPage) {
        const params = this.searchParams.size > 0 ? '&' + this.searchParams.toString() : ''
        window.location.href = baseUrl + searchUrl + '?q=' + searchQuery + params
      }
    }
  },

  computed: {
    ...mapGetters({
      indexFromStore: 'activeTabIndex'
    }),
    activeTabIndex: {
      get () {
        return this.indexFromStore
      },
      set (newIndex) {
        return this.$store.dispatch('setActiveTabIndex', newIndex)
      }
    },
    isOnSearchPage () {
      return _.includes(window.location.href, 'sok')
    },
    ...mapState({
      searchQuery: state => state.search.searchQuery,
      searchResults: state => state.search.searchResults,
      searchFilters: state => state.search.filtered,
      matchingLocations: state => (_.get(state.search.searchResults, 'locations.count') || 0) + (_.get(state.search.searchResults, 'byggnadsInventering.count') || 0),
      matchingResults: state => state.search.searchResults.matches || 0
    })

  },
  created () {
    if (!this.isOnSearchPage) {
      return
    }

    const currentUrl = window.location.href

    if (_.includes(currentUrl, 'karta')) {
      this.activeTabIndex = 0
    } else {
      this.activeTabIndex = 1
    }
  },
  watch: {
    activeTabIndex (tabIndex) {
      // const currentUrl = window.location.href.split('?')[0]
      const currentUrl = window.location.href
      const hasTabInUrl = _.includes(currentUrl, 'lista') || _.includes(currentUrl, 'karta')
      if (hasTabInUrl) {
        window.history.replaceState(null, null, _.replace(currentUrl, tabIndex === 0 ? 'lista' : 'karta', tabIndex === 0 ? 'karta' : 'lista'))
      } else {
        window.history.replaceState(null, null, _.replace(currentUrl, '/sok', tabIndex === 0 ? '/sok/karta' : '/sok/lista'))
      }
    }
  }
}
</script>
